import React, { FC } from "react";
import Creatable from "react-select/creatable";
import { DropdownIndicator } from "../../dropdown/DropdownIndicator";
import { ReactSelectDropdownOption } from "../../dropdown/types";
import {
  customReactSelectTypeableStyles,
  getThemedSelectQtyStyles,
} from "../../dropdown/constants";

import Select, { OptionTypeBase, ValueType } from "react-select";
import { FocusEventHandler } from "react-select/src/types";

interface QuantitySelectProps {
  typeableSelect?: boolean;
  formatCreateLabel: (str: string) => string;
  onBlur: FocusEventHandler;
  onChange: (selected: ValueType<OptionTypeBase, false>) => Promise<void>;
  noOptionsMessage: () => string;
  validNewOption: (inputValue: string) => boolean;
  value: ReactSelectDropdownOption;
  disabled: boolean;
  options: ReadonlyArray<ReactSelectDropdownOption>;
}

export const ItemQuantitySelect: FC<QuantitySelectProps> = (props) => {
  const {
    typeableSelect,
    formatCreateLabel,
    onBlur,
    onChange,
    noOptionsMessage,
    validNewOption,
    value,
    disabled,
    options,
  } = props;
  if (typeableSelect) {
    return (
      <Creatable
        components={{ DropdownIndicator }}
        formatCreateLabel={formatCreateLabel}
        onBlur={onBlur}
        styles={customReactSelectTypeableStyles}
        onChange={onChange}
        noOptionsMessage={noOptionsMessage}
        isValidNewOption={validNewOption}
        value={value}
        disabled={disabled}
        options={options}
      />
    );
  }

  return (
    <Select<ReactSelectDropdownOption>
      components={{ DropdownIndicator }}
      value={value}
      options={options}
      onChange={onChange}
      styles={getThemedSelectQtyStyles()}
      isDisabled={disabled}
      isSearchable={false}
    />
  );
};
